export default "__VITE_ASSET__DT7zHIWd__"